import Axios from "axios";

const state = {
    domain: null,
    project: null,
    buildings: null,
    floors: null,
    units: null,
    isPending: false,
    isContactPending: false,
    baseUrl: process.env.MIX_APP_URL,
    pagination: {
        per_page: 50
    },
    isCycloramaAvailable: false,
    isVirtualTourAvailable: false,
    errors: [],
    message: ''
};

const getters = {

};

const actions = {
    getDomain({state, commit, getters, dispatch}, {
        includes = [],
    } = {}) {
        state.isPending = true;

        return Axios.get('/domain?' + (includes.length > 0 ? ('include=' + includes.join(',')) : '') + '&translatable=1')
            .then(response => {
                commit('SET_DOMAIN', response.data.data);

                Axios.get(`${window.location.origin}/storage/cyclorama/${response.data.data.name.toLowerCase()}/tour.xml`).then( (file) => {
                    commit('SET_IS_CYCLORAMA_AVAILABLE', file.headers['content-type'] === 'application/xml; charset=utf-8' || file.headers['content-type'] === 'text/xml; charset=utf-8');
                })

                Axios.get(`${window.location.origin}/storage/vtour/${response.data.data.name.toLowerCase()}/1/tour.xml`).then( (file) => {
                    commit('SET_IS_VIRTUAL_TOUR_AVAILABLE', file.headers['content-type'] === 'application/xml; charset=utf-8' || file.headers['content-type'] === 'text/xml; charset=utf-8');
                })
            })
            .catch(error => {
                console.warn(error);
            })
            .finally(() => {
                state.isPending = false;
            });
    },
    postContact({state, commit, getters, dispatch}, data) {
        state.isContactPending = true;
        commit('SET_ERRORS', []);

        return Axios.post('/contact', data)
            .then(response => {
                console.warn(response);
                commit('SET_MESSAGE', response.data.message);
            })
            .catch(error => {
                console.warn(error);
                if (error.status === 422) {
                    commit('SET_ERRORS', error.data.errors);
                    console.warn(error);
                }
            })
            .finally(() => {
                state.isContactPending = false;
            });
    }
};

const mutations = {
    SET_DOMAIN(state, domain) {
        state.domain = domain;
    },
    SET_IS_CYCLORAMA_AVAILABLE(state, isAvailable) {
        state.isCycloramaAvailable = isAvailable;
    },
    SET_IS_VIRTUAL_TOUR_AVAILABLE(state, isAvailable){
        state.isVirtualTourAvailable = isAvailable;
    },
    SET_ERRORS(state, errors) {
        state.errors = errors;
    },
    SET_MESSAGE(state, message) {
        state.message = message;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};

